export default "__VITE_ASSET__1e8b06ae__"